module.exports = __webpack_public_path__ + "static/media/migration-success-icon.5681801a.svg";